
import { v4 as uuidv4 } from "uuid";
import { FloatingFeature } from "@models";
import { 
  Spellbook,
  UpgradableNumber 
} from "@dndModels";
import { AbilityScoreExpandedType } from "@dndModels/Types";
import { ABILITY_SCORES_EXPANDED } from "@dndModels/Constants";

export class SpellcastingFeature extends FloatingFeature {
  ability: AbilityScoreExpandedType = "None";
  ability_selectable_key = "";
  table = "";
  level = 0; // Full, Half, Third, etc
  // level_bonus = 0; // 1 for Artificer
  spell_list_ids: string[] = [];
  spell_list_selectable_key = "";
  knowledge_type: "Prepared" | "Known" | "Spellbook" = "Known";
  spellbook: Spellbook | null = null;
  // These can be increased through other features.
  cantrips_max: UpgradableNumber = new UpgradableNumber();
  spells_prepared: UpgradableNumber = new UpgradableNumber();
  // These can be granted through other features
  ritual_casting = true;
  focus = "";
  schools: string[] = [];
  
  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.ability = obj.ability ? obj.ability : "None";
      this.table = obj.table ? obj.table : "";
      this.level = obj.level ? obj.level : 0;
      // this.level_bonus = obj.level_bonus ? obj.level_bonus : 0;
      this.spell_list_ids = obj.spell_list_ids ? obj.spell_list_ids : (obj.spell_list_id ? [obj.spell_list_id] : []);
      this.knowledge_type = obj.knowledge_type ? obj.knowledge_type : "Known";
      this.spellbook = obj.spellbook ? new Spellbook(obj.spellbook) : null;
      if (this.spellbook) {
        this.spellbook.supplies_spells = true;
      }
      if (obj.cantrips_max && obj.cantrips_max.base === undefined) {
        // Translate old set up to new
        this.cantrips_max = new UpgradableNumber();
        this.cantrips_max.base = +obj.cantrips_max;
      } else if (obj.cantrips_max) {
        this.cantrips_max = new UpgradableNumber(obj.cantrips_max);
      } else {
        this.cantrips_max = new UpgradableNumber();
      }
      if (obj.spells_prepared) {
        this.spells_prepared = new UpgradableNumber(obj.spells_prepared);
      } else if (obj.base_spell_count) {
        // Translate old set up to new
        this.spells_prepared = new UpgradableNumber();
        this.spells_prepared.base = +obj.base_spell_count;
        if (obj.spell_count_per_level) {
          this.spells_prepared.add_source_level_mult = +obj.spell_count_per_level;
        }
        if (obj.extra_prepared_from_ability) {
          // this.spells_prepared.add_ability_scores = [obj.extra_prepared_from_ability];
          // this.spells_prepared.add_ability_mod_mult = 1;
          this.spells_prepared.add_stats_groups = [{ 
            true_id: uuidv4().toString(),
            add_ability_scores: [obj.extra_prepared_from_ability],
            mod_or_score: "Mod",
            add_mult: 1,
            multiple_type: "And"
          }];
        }
      } else {
        this.spells_prepared = new UpgradableNumber();
      }
      this.ritual_casting = obj.ritual_casting !== undefined ? obj.ritual_casting : true;
      this.focus = obj.focus ? obj.focus : "";
      
      if (!ABILITY_SCORES_EXPANDED.includes(this.ability)) {
        this.ability = "None";
      }
      this.spell_list_selectable_key = obj.spell_list_selectable_key ? obj.spell_list_selectable_key : "";
      this.schools = obj.schools ? obj.schools : [];
      this.schools = this.schools.filter(o => o !== "Any");
      this.ability_selectable_key = obj.ability_selectable_key ? obj.ability_selectable_key : "";
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.ability = obj.ability ? obj.ability : "None";
  //     this.table = obj.table ? obj.table : "Spellcasting";
  //     this.level = obj.level ? obj.level : 0;
  //     this.level_bonus = obj.level_bonus ? obj.level_bonus : 0;
  //     this.spell_list_ids = obj.spell_list_ids ? obj.spell_list_ids : (obj.spell_list_id ? [obj.spell_list_id] : []);
  //     this.knowledge_type = obj.knowledge_type ? obj.knowledge_type : "Known";
  //     this.spellbook = obj.spellbook ? new Spellbook(obj.spellbook) : null;
  //     if (this.spellbook) {
  //       this.spellbook.supplies_spells = true;
  //     }
  //     if (obj.cantrips_max && obj.cantrips_max.base === undefined) {
  //       // Translate old set up to new
  //       this.cantrips_max = new UpgradableNumber();
  //       this.cantrips_max.base = +obj.cantrips_max;
  //     } else if (obj.cantrips_max) {
  //       this.cantrips_max = new UpgradableNumber(obj.cantrips_max);
  //     } else {
  //       this.cantrips_max = new UpgradableNumber();
  //     }
  //     if (obj.spells_prepared) {
  //       this.spells_prepared = new UpgradableNumber(obj.spells_prepared);
  //     } else if (obj.base_spell_count) {
  //       // Translate old set up to new
  //       this.spells_prepared = new UpgradableNumber();
  //       this.spells_prepared.base = +obj.base_spell_count;
  //       if (obj.spell_count_per_level) {
  //         this.spells_prepared.add_source_level_mult = +obj.spell_count_per_level;
  //       }
  //       if (obj.extra_prepared_from_ability) {
  //         this.spells_prepared.add_ability_scores = [obj.extra_prepared_from_ability];
  //         this.spells_prepared.add_ability_mod_mult = 1;
  //       }
  //     } else {
  //       this.spells_prepared = new UpgradableNumber();
  //     }
  //     this.ritual_casting = obj.ritual_casting !== undefined ? obj.ritual_casting : true;
  //     this.focus = obj.focus ? obj.focus : "";
      
  //     if (!ABILITY_SCORES_EXPANDED.includes(this.ability)) {
  //       this.ability = "None";
  //     }
  //     this.spell_list_selectable_key = obj.spell_list_selectable_key ? obj.spell_list_selectable_key : "";
  //     this.schools = obj.schools ? obj.schools : [];
  //     this.schools = this.schools.filter(o => o !== "Any");
  //     this.ability_selectable_key = obj.ability_selectable_key ? obj.ability_selectable_key : "";
  //   }
  // }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      ability: this.ability,
      ability_selectable_key: this.ability_selectable_key,
      table: this.table,
      level: this.level,
      // level_bonus: this.level_bonus,
      spell_list_ids: this.spell_list_ids,
      spell_list_selectable_key: this.spell_list_selectable_key,
      knowledge_type: this.knowledge_type,
      spellbook: this.spellbook ? this.spellbook.toDBObj() : null,
      cantrips_max: this.cantrips_max.toDBObj(),
      spells_prepared: this.spells_prepared.toDBObj(),
      // base_spell_count: this.base_spell_count,
      // spell_count_per_level: this.spell_count_per_level,
      // extra_prepared_from_ability: this.extra_prepared_from_ability,
      ritual_casting: this.ritual_casting,
      focus: this.focus,
      schools: this.schools
    };
  }

  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof SpellcastingFeature) {
      this.safe_copy(copyMe);
    }
  }

  safe_copy(copyMe: SpellcastingFeature) {
    this.ability = copyMe.ability;
    this.ability_selectable_key = copyMe.ability_selectable_key;
    this.table = copyMe.table;
    this.level = copyMe.level;
    // this.level_bonus = copyMe.level_bonus;
    this.spell_list_ids = copyMe.spell_list_ids;
    this.spell_list_selectable_key = copyMe.spell_list_selectable_key;
    this.spellbook = copyMe.spellbook;
    this.cantrips_max = copyMe.cantrips_max.clone();
    if (copyMe instanceof SpellcastingFeature) {
      this.knowledge_type = copyMe.knowledge_type;
      this.spells_prepared = copyMe.spells_prepared.clone();
    }
    this.ritual_casting = copyMe.ritual_casting;
    this.focus = copyMe.focus;
    this.schools = copyMe.schools;
  }

  clone(drop_ids = false): SpellcastingFeature {
    const new_obj = new SpellcastingFeature();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  get spell_count_per_level() {
    return this.spells_prepared.add_source_level_mult;
  }

  get extra_prepared_from_ability() {
    return this.spells_prepared.add_stats_groups.flatMap(o => o.add_ability_scores); // .add_ability_scores;
  }

  get base_spell_count() {
    return this.spells_prepared.base;
  }
}
